export default "__VITE_ASSET__0e5727a4__"